import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router";

import { useDialog } from "@datanac/datanac-mui-toolkit";
import { useMediaQuery } from "@mui/material";
import { AppContext } from "App";
import { FinancialIcon } from "components/Icons/Icons";
import WorkspaceActionBar from "components/Workspaces/WorkspaceActionBar";
import WorkspaceHeader from "components/Workspaces/WorkspaceHeader";
import WorkspacePageHeader from "components/Workspaces/WorkspacePageHeader";

import { useChatAssistantAttachments } from "../../contexts/useChatAssistantAttachments";
import { InterviewDialog } from "./InterviewDialog";

export default function InterviewPage() {
  const { globalState, globalDispatch } = useContext(AppContext);
  const { year } = useParams();
  const { addAttachments } = useChatAssistantAttachments();

  const isPrint = useMediaQuery("print");
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("md"), { noSsr: true }) && !isPrint;

  const { component: confirmDialogComponent } = useDialog();

  const [currentYear, setCurrentYear] = useState(year || globalState?.crop_year);
  useEffect(() => {
    globalDispatch({
      type: "update",
      payload: {
        key: "crop_year",
        value: currentYear,
      },
    });
  }, [currentYear]);

  // Cleanup attachments when component unmounts (user navigates away)
  useEffect(() => {
    return () => {
      addAttachments([]);
    };
  }, []);

  return (
    <>
      <WorkspaceHeader
        title="Financial interview"
        category={{
          title: "Financial Analysis",
          icon: <FinancialIcon />,
        }}
      />

      <WorkspacePageHeader title="Year" currentYear={currentYear} onYearChange={setCurrentYear} />

      <InterviewDialog year={currentYear} />

      {!isSmall && <WorkspaceActionBar content={<></>} />}

      {confirmDialogComponent}
    </>
  );
}
